<template>
  <div>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :showPage="false"
               :showSearchForm="false"
               tableApi="admin/lottery/itemLists"
    >

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";

  export default {
    name: "lists",
    components:{pageTable},
    data() {
      return {
        tableColumn: [
          {title:'编号',key:'item_id',align:'center'},
          {title:'奖品',key:'item_name',align:'center'},
          {title:'中奖权重',key:'weight',align:'center',render:(h,params)=>{
              if (params.row.$isEdit){
                return h('div',[
                  h('input',{
                    domProps:{value:params.row.weight},
                    on:{
                      input: function (event) {
                        params.row.weight = event.target.value;
                      },
                    }
                  }),
                  h('Button',{
                    props:{
                      size:'small'
                    },
                    on:{
                      click:()=>{this.setWeight(params.row)}
                    }
                  },'保存'),
                ])
              }else{
                return  h('div',[
                  h('span',params.row.weight),
                  h('Button',{
                    props:{
                      size:'small'
                    },
                    on:{
                      click:()=>{this.$set(params.row,'$isEdit',true)}
                    }
                  },'修改'),
                ])
              }
            }},
          {title:'中奖概率',key:'success_rate',align:'center'},
        ],
        tableData: [],
      }
    },
    methods: {
      async setWeight(item){
        let res = await this.$commonFun.postProxy('admin/lottery/setWeight',{item_id:item.item_id,weight:item.weight});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$refs.table.getLists()
          })
        })
      }
    },
    mounted() {

    },
  }
</script>

<style scoped>
  .drawer-footer{
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
</style>
